import Select, { SelectProps } from "@/components/Select";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";

const SidebarSelect = <T extends { label: string; value: unknown }>({ btnSx, menuSx, ...props }: SelectProps<T>) => {
    return (
        <Select
            btnSx={{
                backgroundColor: themeColors.neutralWhite,
                border: `1px solid ${themeColors.neutral1}`,
                borderRadius: "4rem",
                padding: `${spacing.XS} ${spacing.XS_2}`,
                fontSize: "1.4rem",
                fontWeight: "600",
                gap: spacing.XS,
                maxWidth: "15rem",
            }}
            menuSx={{
                backgroundColor: "blue",
                border: `1px solid ${themeColors.neutral2}`,
                width: "fit-content",
                ...menuSx,
            }}
            transitionOrigin={{
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                },
            }}
            {...props}
        />
    );
};

export default SidebarSelect;
